<!-- Main container for the Facility Management interface -->
<main tuiNavigationMain [style.border]="'0px!important'">

  <!-- Header section with title and description -->
  <div [style.grid-column]="'2 / span 10'" [style.margin-top.rem]="1" [style.paddingTop.rem]="1"
    [style.paddingBottom.rem]="1">
    <header tuiHeader="h4">
      <hgroup tuiTitle>
        <h4><span [tuiSkeleton]="isLoading()">Facility Management</span>
        </h4>
        <p tuiSubtitle><span [tuiSkeleton]="isLoading()">Configure facilities, pricing models, and
            manage facility services</span></p>
      </hgroup>
    </header>
    <hr />
  </div>

  <!-- Main content area -->
  <div [style.grid-column]="'2 / span 10'">
    <!-- Facility type selection card -->
    <div tuiAppearance="outline-grayscale" tuiCardLarge tuiForm="m" [style.borderRadius.rem]="0.75">
      <div class="flex gap-4 justify-between">
        <!-- Left: Facility type dropdown selector -->
        <div class="flex-1">
          <form [formGroup]="vehicleSelectionForm" class="flex">
            <p tuiSubtitle [style.width.rem]="9"><b [tuiSkeleton]="isLoading()">Add Facilities</b></p>
            <ng-container *tuiRepeatTimes="let index of 1">
              <div [style.width.%]="100">
                <!-- Dropdown for selecting facility type with custom content template -->
                <tui-textfield tuiChevron [content]="selectedCard && content" [stringify]="stringify"
                  [tuiSkeleton]="isLoading()">
                  <input placeholder="Select facility type to add" tuiSelect
                    [formControl]="vehicleSelectionForm.controls.selectedCard" />

                  <tui-data-list-wrapper *tuiTextfieldDropdown new [itemContent]="content"
                    [items]="getFilteredFacilitiesTypes()" />
                </tui-textfield>
                <!-- Custom template for dropdown items showing facility icon and name -->
                <ng-template #content let-card>
                  <div class="card selected">
                    <tui-thumbnail-card [style.background-color]="card.name | facilityIconStyle:'bg'"
                      [style.color]="card.name | facilityIconStyle:'text':isDarkMode()"
                      style="border-radius: 0.75rem; box-shadow: none;">
                      <img [src]="card.name | facilityIconStyle:'icon':isDarkMode()" style="width: 24px; height: 24px;margin-left: 6px !important;
    margin-top: 5px !important;" alt="{{ card.name }} icon">
                    </tui-thumbnail-card>
                    {{ card.name }}
                  </div>
                </ng-template>
              </div>
            </ng-container>
          </form>
        </div>

        <!-- Right: Add Facilities button -->
        <div class="flex-1 btn-flex">
          <button iconStart="@tui.plus" tuiTextfieldSize="s" size="m" tuiButton type="button"
            (click)="openFacilityDrawerWithSelection()" [appPermissionDisable]="'Facility Services'"
            [appPermissionAction]="'create'" [appPermissionSubModule]="'Facilities Setup'" [tuiSkeleton]="isLoading()"
            class="add-type-btn" [class.add-type-btn-disabled]="isAddTypeDisabled()"
            [tuiAppearanceState]="isAddTypeDisabled() ? 'disabled' : null">
            Add Facilities
          </button>


          <app-facility-drawer #facilityDrawer [facilityDataForEdit]="facilityDataForEdit" [restrictPastDates]="true"
            [parkingId]="parkingId" (facilityCreated)="onFacilityCreated($event)">
          </app-facility-drawer>
        </div>


      </div>
    </div>

    <!-- Tax preview toggle switch -->
    <!-- <label tuiCell size="m" style="background-color: var(--tui-background-neutral-1);" [style.margin-top.rem]="1.25">
      <div tuiTitle>
        <div class="flex small-text" style="font: var(--tui-font-text-ui-s); gap: 0rem;">
          <span> Show tax preview:</span> &nbsp;<b> {{statusText()}}</b>
        </div>
      </div>

      <div class="flex" [style.gap.rem]="0.5">
        <span [style.color]="'var(--tui-text-secondary)'"> {{statusTextYesNo()}}</span>
        <input tuiSwitch type="checkbox" [(ngModel)]="switch" />
      </div>
    </label> -->
  </div>


  <!-- ================= LOADING SKELETON ================= -->
  <div *ngIf="isLoading()" [style.grid-column]="'2 / span 10'" tuiAppearance="outline-grayscale" tuiCardLarge
    tuiForm="m" [style.margin-top.rem]="1.25" [style.widht.%]="100" [style.borderRadius.rem]="0.75">
    <div class="flex justify-between card-head">
      <button tuiCardLarge tuiCell tuiSurface="floating" type="button" [style.paddingLeft.rem]=".7" style="width: auto">
        <tui-avatar appearance="custom" class="vehicle-icon" [tuiSkeleton]="true">
          <img src="assets/images/icons/modules/taxes.svg" />
        </tui-avatar>
        <div tuiTitle>
          <div class="flex">
            <div style="font-weight: var(--bold); width: max-content; border-radius: 4px;" [tuiSkeleton]="true">
              Test Vehicle
            </div>
            <div style="margin-left: .5rem;">
              <tui-badge appearance="positive" tuiStatus size="m" [tuiSkeleton]="true">
                Active
              </tui-badge>
            </div>
          </div>
          <div tuiSubtitle style="margin-inline-start: 0; width: max-content; border-radius: 4px;" [tuiSkeleton]="true">
            8 pricing tiers • Capacity: 700 • Tax: CGST (18%), SGST (8%)
          </div>
        </div>
      </button>

      <aside tuiAccessories>
        <div class="flex">
          <span>
            <div [tuiSkeleton]="true"
              style="border-radius: 4px; display: inline-flex; justify-content: center; align-items: center; width: 28px; height: 28px;">
              <button appearance="flat" size="s" tuiIconButton type="button" class="action-icon">
                <tui-icon icon="@tui.pen-line"></tui-icon>
              </button>
            </div>
          </span>
          <span>
            <div [tuiSkeleton]="true"
              style="border-radius: 4px; display: inline-flex; justify-content: center; align-items: center; width: 28px; height: 28px; margin-left: 0.25rem;">
              <button appearance="flat" size="s" tuiIconButton type="button" class="action-icon">
                <tui-icon icon="@tui.trash"></tui-icon>
              </button>
            </div>
          </span>
        </div>
      </aside>
    </div>

    <!-- Table -->
    <tui-scrollbar waIntersectionRoot class="scrollbar" [style.width.%]="100" [style.margin-top.rem]=".3">
      <table size="s" tuiTable class="table"
        [columns]="['icon', 'duration', 'minHours', 'maxHours', 'price', 'withTax', 'unit', 'actions']"
        [style.width.%]="100">
        <thead tuiThead>
          <tr tuiThGroup>
            <th tuiTh [style.width.%]="1"></th>
            <th tuiTh class="first"><span [tuiSkeleton]="true ? 'ITEM NAME' : ''">{{true ? '' : 'ITEM NAME
                }}</span></th>
            <th tuiTh><span [tuiSkeleton]="true ? 'MIN. HOURS' : ''">{{true ? '' : 'MIN. HOURS'}}</span></th>
            <th tuiTh><span [tuiSkeleton]="true ? 'MAX. HOURS' : ''">{{true ? '' : 'MAX. HOURS'}}</span></th>
            <th tuiTh><span [tuiSkeleton]="true ? 'PRICE' : ''">{{true ? '' : 'PRICE'}}</span></th>
            <th tuiTh [style.display]="switch ? 'table-cell' : 'none'"><span
                [tuiSkeleton]="true ? 'WITH TAX' : ''">{{true ? '' : 'WITH TAX'}}</span></th>
            <!-- <th tuiTh [style.width.%]="15"><span [tuiSkeleton]="true ? 'UNIT TYPE' : ''">{{true ? '' : 'UNIT
                TYPE'}}</span></th> -->
            <th tuiTh class="number"></th>
          </tr>
        </thead>
        <tbody tuiTbody [data]="[{id:1}, {id:2}, {id:3}, {id:4}, {id:5}, {id:6}, {id:7}, {id:8}]">
          <tr
            *ngFor="let item of [{id:1, dur: '0h - 3h', min: '0h', max: '3h', p: 10, t: 12.60}, {id:2, dur: '3h - 6h', min: '3h', max: '6h', p: 30, t: 37.80}, {id:3, dur: '15h - 18h', min: '15h', max: '18h', p: 70, t: 88.20}, {id:4, dur: '18h - 21h', min: '18h', max: '21h', p: 80, t: 100.80}, {id:5, dur: '6h - 9h', min: '6h', max: '9h', p: 40, t: 50.40}, {id:6, dur: '9h - 12h', min: '9h', max: '12h', p: 50, t: 63.00}, {id:7, dur: '12h - 15h', min: '12h', max: '15h', p: 60, t: 75.60}, {id:8, dur: '21h - 24h', min: '21h', max: '24h', p: 90, t: 113.40}]"
            tuiTr>

            <td *tuiCell="'icon'" tuiTd [style.padding-right.rem]="0" [style.padding-left.rem]="0">
              <div class="flex items-center" [style.padding]="'0.25rem'">
                <div [tuiSkeleton]="true"
                  style="border-radius: 4px; width: 20px; min-width: 20px; height: 20px; min-height: 20px;">
                  <tui-icon size="xs" icon="@tui.grip-vertical" [style.color]="'var(--tui-text-placeholder)'"
                    [style.font-size.rem]="1.25" />
                </div>
              </div>
            </td>

            <td *tuiCell="'duration'" tuiTd>
              <div class="flex"><span [tuiSkeleton]="true ? '0h ---------- 3h' : ''">{{true ? '' : item.dur}}</span>
              </div>
            </td>

            <td *tuiCell="'minHours'" tuiTd>
              <span [tuiSkeleton]="true ? '00000000h' : ''">{{true ? '' : item.min}}</span>
            </td>

            <td *tuiCell="'maxHours'" tuiTd>
              <span [tuiSkeleton]="true ? '00000000h' : ''">{{true ? '' : item.max}}</span>
            </td>

            <td *tuiCell="'price'" tuiTd>
              <span [tuiSkeleton]="true ? '00.0000000000.00' : ''">{{true ? '' : currencySymbol + (item.p |
                number:'1.2-2')}}</span>
            </td>

            <td *tuiCell="'withTax'" tuiTd [style.display]="switch ? 'table-cell' : 'none'">
              <span [tuiSkeleton]="true ? '00.0000.0000.00' : ''">{{true ? '' : currencySymbol + (item.t |
                number:'1.2-2')}}</span>
            </td>

            <!-- <td *tuiCell="'unit'" tuiTd>
              <tui-chip size="xs" appearance="neutral" [tuiSkeleton]="true">Hourly</tui-chip>
            </td> -->

            <td *tuiCell="'actions'" tuiTd class="number">
              <div class="flex" style="gap: 0.25rem; align-items: center; justify-content: flex-end;">
                <div [tuiSkeleton]="true"
                  style="border-radius: 4px; display: inline-flex; justify-content: center; align-items: center; width: 28px; height: 28px; background-color: red!important;">
                  <button appearance="flat" size="xs" tuiIconButton type="button" iconStart="@tui.pen-line"></button>
                </div>
                <div [tuiSkeleton]="true"
                  style="border-radius: 4px; display: inline-flex; justify-content: center; align-items: center; width: 28px; height: 28px; background-color: red!important;">
                  <button appearance="flat" size="xs" tuiIconButton type="button" iconStart="@tui.trash"></button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </tui-scrollbar>


    <!-- Add new pricing tier section - hidden when 24h tier exists -->
    <div class="add-more-tier">
      <header tuiHeader="h6">
        <hgroup tuiTitle>
          <p tuiSubtitle><span [tuiSkeleton]="true">Price Items</span></p>
        </hgroup>
        <aside tuiAccessories>
          <div class="flex" style="gap: 1rem; align-items: center;">
            <!-- Add new pricing tier button -->
            <button appearance="outline" iconStart="@tui.plus" size="s" tuiButton type="button" [tuiSkeleton]="true">
              Add Price Item
            </button>
          </div>
        </aside>
      </header>
    </div>

    <!-- Image container with upload button -->
    <div class="icon-list" style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap;">
      <!-- Display uploaded images if available -->
      <tui-avatar appearance="custom" class="icon-faclity" [tuiSkeleton]="true">
        <img src="" alt="facilities" />
      </tui-avatar>

      <!-- Upload button -->
      <button appearance="secondary" size="l" tuiButton type="button" class="facility-add-image-btn"
        [tuiSkeleton]="true">
        Photos
      </button>
    </div>

    <!-- Footer with facility description -->
    <footer>
      <p tuiText class="tui-text_s">
        <span [tuiSkeleton]="true">Secure helmet storage with individual compartments.</span>
      </p>
    </footer>
  </div>
  <!-- ================= END  SKELETON ================= -->


  <!-- Loading and status states -->
  <div [style.grid-column]="'2 / span 10'">
    <!-- Empty state for when no facility types are added yet -->
    <div *ngIf="vehicleContainers().length === 0 && !isLoading()" tuiAppearance="outline-grayscale" tuiCardLarge
      tuiForm="m" [style.margin-top.rem]="1.25" [style.widht.%]="100" [style.borderRadius.rem]="0.75"
      class="no-passes-message" style="text-align: center; padding: 2rem; color: var(--tui-text-secondary);">
      <tui-block-status size="m">
        <img alt="survived" src="assets/images/icons/going-up.svg" tuiSlot="top" />
        <h4 [style.color]="'var(--tui-text-primary)'">No facility types configured yet</h4>
        <span [style.color]="'var(--tui-text-secondary)'">Add your first facility type to start configuring pricing
          tiers</span>
        <div class="nothing-here-btn-flex">
          <!-- Add new pricing tier button -->
          <button appearance="outline" size="s" tuiButton type="button" (click)="addVehicleTypeFromButton()"
            iconStart="@tui.plus" [style.margin-top]="'1rem'" [appPermissionDisable]="'Facility Services'"
            [appPermissionAction]="'create'" [appPermissionSubModule]="'Facilities Setup'" class="add-type-btn">
            Add First Facility Type
          </button>
        </div>
      </tui-block-status>
    </div>
  </div>

  <!-- Dynamic container for each facility type -->
  <ng-container *ngFor="let container of vehicleContainers()">
    <!-- Individual facility type card -->
    <div [style.grid-column]="'2 / span 10'" tuiAppearance="outline-grayscale" tuiCardLarge tuiForm="m"
      [style.margin-top.rem]="1.25" [style.widht.%]="100" [style.borderRadius.rem]="0.75">
      <!-- Facility type header with icon, name, status, and controls -->
      <div class="flex justify-between card-head">
        <!-- Left: Facility info button -->
        <button tuiCardLarge tuiCell tuiSurface="floating" type="button" [style.paddingLeft.rem]=".7"
          style="width: auto;">
          <!-- Facility icon with SVG or initials fallback -->
          <tui-avatar appearance="custom" [style.background-color]="container.facilityType | facilityIconStyle:'bg'"
            [style.color]="container.facilityType | facilityIconStyle:'text':isDarkMode()" style="font-weight: bold;"
            class="vehicle-icon">
            <img [src]="container.facilityType | facilityIconStyle:'icon':isDarkMode()"
              alt="{{ container.facilityType }} icon">
          </tui-avatar>
          <div tuiTitle>
            <div class="flex">
              <span style="font-weight: var(--bold);"> {{ container.facilityType }} </span>
              <!-- Active/Inactive status badge -->
              <tui-badge [appearance]="container.isActive ? 'positive' : 'negative'" tuiStatus size="m">
                {{ (container.isActive ? 'Active' : 'Inactive') }}
              </tui-badge>

              <tui-chip [size]="'xs'" appearance="neutral">
                {{ (container.pricingType || 'No Pricing Type') }}
              </tui-chip>
            </div>
            <!-- Pricing summary subtitle -->
            <div tuiSubtitle style="margin-inline-start: 0;">
              {{ ((container | containerStat:'tiers') + ' pricing tiers • Capacity: ' +
              (container.capacity || 'N/A') + ' • Tax: ' +
              (container | containerStat:'tax')) }}
            </div>
          </div>
        </button>

        <!-- Right: Facility controls (active toggle and delete) -->
        <aside tuiAccessories>
          <div class="flex items-center gap-3">



            <!-- Active/Inactive toggle switch -->
            <!-- <span style="margin-top: 6px;">
              <input tuiSwitch type="checkbox" [ngModel]="container.isActive"
                (ngModelChange)="toggleVehicleActive(container)" />
            </span> -->


            <!-- Edit facility type button -->
            <span>
              <button appearance="flat" size="s" tuiIconButton type="button" (click)="onEditButtonClick(container)"
                [appPermissionDisable]="'Facility Services'" [appPermissionAction]="'update'"
                [appPermissionSubModule]="'Facilities Setup'" [title]="'Edit ' + container.facilityType"
                class="action-icon">
                <tui-icon icon="@tui.pen-line"></tui-icon>
              </button>
            </span>

            <!-- Delete facility type button -->
            <span>
              <button appearance="flat" size="s" tuiIconButton type="button" (click)="onTrashButtonClick(container.id)"
                [appPermissionDisable]="'Facility Services'" [appPermissionAction]="'delete'"
                [appPermissionSubModule]="'Facilities Setup'" [disabled]="deletingRowId() === container.id"
                [title]="deletingRowId() === container.id ? 'Deleting...' : 'Delete facility type'"
                [style.opacity]="deletingRowId() === container.id ? '0.7' : '1'" class="action-icon">
                <!-- Show loader when deleting, otherwise show trash icon -->
                <ng-container *ngIf="deletingRowId() === container.id; else trashIcon">
                  <div class="loader-container">
                    <tui-loader size="xs"></tui-loader>
                  </div>
                </ng-container>
                <ng-template #trashIcon>
                  <tui-icon icon="@tui.trash"></tui-icon>
                </ng-template>
              </button>
            </span>
          </div>

        </aside>
      </div>

      <!-- Scrollable pricing tiers table -->
      <tui-scrollbar waIntersectionRoot class="scrollbar" [hidden]="true" [style.width.%]="100"
        [style.margin-top.rem]=".3">
        <table size="s" tuiTable class="table" [columns]="getContainerColumns(container)" [style.width.%]="100"
          [class.is-valet]="container.facilityType && container.facilityType.toLowerCase().includes('valet')">
          <!-- Table header -->
          <thead tuiThead>
            <tr tuiThGroup>
              <th tuiTh [style.width.%]="1"></th>
              <!-- Time Based & Hour Based Columns -->
              <th *ngIf="container.pricingType === 'Time Based' || container.pricingType === 'Hour Based'" tuiTh
                class="first">
                ITEM NAME
              </th>
              <th *ngIf="container.pricingType === 'Time Based' || container.pricingType === 'Hour Based'" tuiTh>
                MIN. HOURS
              </th>
              <th *ngIf="container.pricingType === 'Time Based' || container.pricingType === 'Hour Based'" tuiTh>
                MAX. HOURS
              </th>
              <th *ngIf="container.pricingType === 'Time Based' || container.pricingType === 'Hour Based'" tuiTh>
                PRICE
              </th>
              <!-- Tax column - conditionally shown based on switch -->
              <th *ngIf="(container.pricingType === 'Time Based' || container.pricingType === 'Hour Based') && switch"
                tuiTh>
                WITH TAX
              </th>
              <th *ngIf="container.pricingType === 'Time Based' || container.pricingType === 'Hour Based'" tuiTh
                [style.width.%]="20">
                DESCRIPTION
              </th>
              <!-- <th *ngIf="container.pricingType === 'Time Based' || container.pricingType === 'Hour Based'" tuiTh
                class="unit-type-col">
                UNIT TYPE
              </th> -->

              <!-- Flat Rate Columns -->
              <th *ngIf="container.pricingType === 'Flat Rate'" tuiTh class="first">
                ITEM NAME
              </th>
              <th *ngIf="container.pricingType === 'Flat Rate'" tuiTh>
                PRICE
              </th>
              <!-- Tax column - conditionally shown based on switch -->
              <th *ngIf="container.pricingType === 'Flat Rate' && switch" tuiTh>
                WITH TAX
              </th>
              <th *ngIf="container.pricingType === 'Flat Rate'" tuiTh [style.width.%]="30">
                DESCRIPTION
              </th>

              <!-- Per Unit, Energy Consumption, Per Day Columns -->
              <th
                *ngIf="container.pricingType === 'Per Unit' || container.pricingType === 'Energy Consumption' || container.pricingType === 'Per Day'"
                tuiTh class="first">
                ITEM NAME
              </th>
              <th
                *ngIf="container.pricingType === 'Per Unit' || container.pricingType === 'Energy Consumption' || container.pricingType === 'Per Day'"
                tuiTh>
                PRICE
              </th>
              <!-- Tax column - conditionally shown based on switch -->
              <th
                *ngIf="(container.pricingType === 'Per Unit' || container.pricingType === 'Energy Consumption' || container.pricingType === 'Per Day') && switch"
                tuiTh>
                WITH TAX
              </th>
              <th
                *ngIf="container.pricingType === 'Per Unit' || container.pricingType === 'Energy Consumption' || container.pricingType === 'Per Day'"
                tuiTh>
                AVL. QUANTITY
              </th>
              <th
                *ngIf="container.pricingType === 'Per Unit' || container.pricingType === 'Energy Consumption' || container.pricingType === 'Per Day'"
                tuiTh [style.width.%]="30">
                DESCRIPTION
              </th>

              <th tuiTh class="number">
              </th>
            </tr>
          </thead>

          <!-- Table body with pricing tier rows -->
          <tbody tuiTbody [data]="container.tableRows">
            <!-- Skeleton Rows for Loading State -->
            <ng-container *ngIf="isLoading() && (!container.tableRows || container.tableRows.length === 0)">
              <tr *ngFor="let dummy of [1, 2, 3]" tuiTr>
                <td *tuiCell="'icon'" tuiTd [style.padding-right.rem]="0" [style.padding-left.rem]="0">
                  <div class="flex items-center" [style.padding]="'0.25rem'">
                    <div [tuiSkeleton]="true" style="width: 20px; height: 20px; border-radius: 4px; margin: auto;">
                    </div>
                  </div>
                </td>
                <td *tuiCell="'duration'" tuiTd>
                  <div [tuiSkeleton]="true" style="width: 80px; height: 20px; border-radius: 4px;"></div>
                </td>
                <td *tuiCell="'minHours'" tuiTd>
                  <div [tuiSkeleton]="true" style="width: 40px; height: 20px; border-radius: 4px;"></div>
                </td>
                <td *tuiCell="'maxHours'" tuiTd>
                  <div [tuiSkeleton]="true" style="width: 40px; height: 20px; border-radius: 4px;"></div>
                </td>
                <td *tuiCell="'tierName'" tuiTd>
                  <div [tuiSkeleton]="true" style="width: 80px; height: 20px; border-radius: 4px;"></div>
                </td>
                <td *tuiCell="'price'" tuiTd>
                  <div [tuiSkeleton]="true" style="width: 60px; height: 20px; border-radius: 4px;"></div>
                </td>
                <td *tuiCell="'withTax'" tuiTd [style.display]="switch ? 'table-cell' : 'none'">
                  <div [tuiSkeleton]="true" style="width: 60px; height: 20px; border-radius: 4px;"></div>
                </td>
                <td *tuiCell="'available'" tuiTd>
                  <div [tuiSkeleton]="true" style="width: 40px; height: 20px; border-radius: 4px;"></div>
                </td>
                <td *tuiCell="'description'" tuiTd>
                  <div [tuiSkeleton]="true" style="width: 120px; height: 20px; border-radius: 4px;"></div>
                </td>
                <!-- <td *tuiCell="'unitType'" tuiTd>
                  <div [tuiSkeleton]="true" style="width: 50px; height: 20px; border-radius: 10px;"></div>
                </td> -->
                <td *tuiCell="'unit'" tuiTd>
                </td>
                <td *tuiCell="'actions'" tuiTd class="number last">
                  <div class="flex" style="gap: 0.25rem; justify-content: flex-end;">
                    <div [tuiSkeleton]="true" style="width: 24px; height: 24px; border-radius: 4px;"></div>
                    <div [tuiSkeleton]="true" style="width: 24px; height: 24px; border-radius: 4px;"></div>
                  </div>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngFor="let row of container.tableRows; trackBy: trackByIndex; let i = index">
              <tr *ngIf="row && row.id" tuiTr [draggable]="true" (dragstart)="onDragStart($event, row, i)"
                (dragover)="onDragOver($event)" (drop)="onDrop($event, row, i, container)"
                (mouseenter)="row.hovered = true" (mouseleave)="row.hovered = false" [style.cursor]="'grab'"
                [style.user-select]="'none'">
                <!-- Icon column with drag indicator -->
                <td *tuiCell="'icon'" tuiTd [style.padding-right.rem]="0" [style.padding-left.rem]="0">
                  <div class="flex items-center" [style.padding]="'0.25rem'">
                    <tui-icon size="xs" icon="@tui.grip-vertical" [style.color]="'var(--tui-text-placeholder)'"
                      title="Drag to reorder tier" [style.font-size.rem]="1.25"
                      [style.color]="'var(--tui-text-placeholder)'" />
                  </div>
                </td>
                <!-- Time Based & Hour Based Row -->
                <ng-container *ngIf="container.pricingType === 'Time Based' || container.pricingType === 'Hour Based'">
                  <!-- Duration column with unit type icon -->
                  <td *tuiCell="'duration'" tuiTd>
                    <!-- Display mode -->
                    <ng-container *ngIf="!row.isEditMode; else durationEdit">
                      <div class="flex">
                        <span>{{ row.duration }}</span>
                      </div>
                    </ng-container>
                    <!-- Edit mode with text input -->
                    <ng-template #durationEdit>
                      <div class="flex" (mousedown)="$event.stopPropagation()">
                        <ng-container
                          *ngIf="container.facilityType && container.facilityType.toLowerCase().includes('valet'); else normalDurationInput">
                          <tui-select [ngModel]="row.duration || null" [ngModelOptions]="options"
                            (ngModelChange)="onValueChange($event, 'duration', row, container.tableRows)"
                            (mousedown)="$event.stopPropagation()" style="height: 42px;border: none; width: 90%;"
                            panelClass="tui-select-panel">
                            Select item
                            <tui-data-list-wrapper *tuiDataList [items]="getAvailableVehicleServices(container, row)"
                              size="s"></tui-data-list-wrapper>
                          </tui-select>
                        </ng-container>
                        <ng-template #normalDurationInput>
                          <tui-textfield (mousedown)="$event.stopPropagation()">
                            <input tuiTextfield [ngModel]="row.duration" [ngModelOptions]="options"
                              (ngModelChange)="onValueChange($event, 'duration', row, container.tableRows)"
                              (keydown.enter)="saveRowInContainer(container, row)"
                              [class.field-error]="shouldShowTierNameError(row)"
                              style="width:90%; border: .125rem solid var(--tui-border-focus); outline: none;"
                              placeholder="Enter pricing tier" />
                          </tui-textfield>
                        </ng-template>
                      </div>
                    </ng-template>
                  </td>

                  <!-- Min Hours column with edit functionality -->
                  <td *tuiCell="'minHours'" tuiTd>
                    <!-- Display mode -->
                    <ng-container *ngIf="!row.isEditMode; else minHoursEdit">
                      <span>{{ row.minHours }}</span>
                    </ng-container>
                    <!-- Edit mode: min fixed at 0h unless container already has a Flat item -->
                    <ng-template #minHoursEdit>
                      <ng-container *ngIf="hasFixedMinHours(row, container); else minHoursEditable">
                        <span>{{ row.minHours || '0h' }}</span>
                      </ng-container>
                      <ng-template #minHoursEditable>
                        <tui-textfield (mousedown)="$event.stopPropagation()">
                          <input tuiInputNumber [ngModel]="getNumericValueForInput(row.minHours)"
                            [ngModelOptions]="options"
                            (ngModelChange)="onValueChange($event, 'minHours', row, container.tableRows)"
                            [tuiNumberFormat]="{precision: 0}"
                            style="border: .125rem solid var(--tui-border-focus); outline: none; width:90%"
                            placeholder="Enter min hours" />
                        </tui-textfield>
                      </ng-template>
                    </ng-template>
                  </td>

                  <!-- Max Hours column with edit functionality -->
                  <td *tuiCell="'maxHours'" tuiTd>
                    <!-- Display mode -->
                    <ng-container *ngIf="!row.isEditMode; else maxHoursEdit">
                      <span>{{ row.maxHours }}</span>
                    </ng-container>
                    <!-- Edit mode -->
                    <ng-template #maxHoursEdit>
                      <tui-textfield (mousedown)="$event.stopPropagation()">
                        <input tuiInputNumber [ngModel]="getNumericValueForInput(row.maxHours)"
                          [ngModelOptions]="options"
                          (ngModelChange)="onValueChange($event, 'maxHours', row, container.tableRows)"
                          [min]="getMaxHoursInputMin(row)" [max]="getMaxHoursInputMax(row)"
                          [tuiNumberFormat]="{precision: 0}"
                          style="border: .125rem solid var(--tui-border-focus); outline: none; width:90%"
                          placeholder="Enter max hours" />
                      </tui-textfield>
                    </ng-template>
                  </td>
                </ng-container>

                <!-- Flat Rate Row -->
                <ng-container *ngIf="container.pricingType === 'Flat Rate'">
                  <!-- Tier Name column -->
                  <td *tuiCell="'tierName'" tuiTd>
                    <!-- Display mode -->
                    <ng-container *ngIf="!row.isEditMode; else tierNameEdit">
                      <span>{{ (row.tierName || row.duration) }}</span>
                    </ng-container>
                    <!-- Edit mode -->
                    <ng-template #tierNameEdit>
                      <ng-container
                        *ngIf="container.facilityType && container.facilityType.toLowerCase().includes('valet'); else normalInput">
                        <tui-select [ngModel]="(row.tierName || row.duration) || null" [ngModelOptions]="options"
                          (ngModelChange)="onValueChange($event, 'tierName', row, container.tableRows)"
                          (mousedown)="$event.stopPropagation()" style="height: 42px;border: none;"
                          panelClass="tui-select-panel">
                          Select item
                          <tui-data-list-wrapper *tuiDataList [items]="getAvailableVehicleServices(container, row)"
                            size="s"></tui-data-list-wrapper>
                        </tui-select>
                      </ng-container>
                      <ng-template #normalInput>
                        <tui-textfield (mousedown)="$event.stopPropagation()">
                          <input tuiTextfield [ngModel]="row.tierName || row.duration" [ngModelOptions]="options"
                            (ngModelChange)="onValueChange($event, 'tierName', row, container.tableRows)"
                            (keydown.enter)="saveRowInContainer(container, row)"
                            [class.field-error]="shouldShowTierNameError(row)"
                            style="width:90%; border: .125rem solid var(--tui-border-focus); outline: none;"
                            placeholder="Enter tier name" />
                        </tui-textfield>
                      </ng-template>
                    </ng-template>
                  </td>
                </ng-container>

                <!-- Per Unit, Energy Consumption, Per Day Row -->
                <ng-container
                  *ngIf="container.pricingType === 'Per Unit' || container.pricingType === 'Energy Consumption' || container.pricingType === 'Per Day'">
                  <!-- Tier Name column -->
                  <td *tuiCell="'tierName'" tuiTd>
                    <!-- Display mode -->
                    <ng-container *ngIf="!row.isEditMode; else tierNameEdit2">
                      <span>{{ (row.tierName || row.duration) }}</span>
                    </ng-container>
                    <!-- Edit mode -->
                    <ng-template #tierNameEdit2>
                      <ng-container
                        *ngIf="container.facilityType && container.facilityType.toLowerCase().includes('valet'); else normalTierInput">
                        <tui-select [ngModel]="(row.tierName || row.duration) || null" [ngModelOptions]="options"
                          (ngModelChange)="onValueChange($event, 'tierName', row, container.tableRows)"
                          (mousedown)="$event.stopPropagation()" style="height: 42px;border: none;"
                          panelClass="tui-select-panel">
                          Select item
                          <tui-data-list-wrapper *tuiDataList [items]="getAvailableVehicleServices(container, row)"
                            size="s"></tui-data-list-wrapper>
                        </tui-select>
                      </ng-container>
                      <ng-template #normalTierInput>
                        <tui-textfield (mousedown)="$event.stopPropagation()">
                          <input tuiTextfield [ngModel]="row.tierName || row.duration" [ngModelOptions]="options"
                            (ngModelChange)="onValueChange($event, 'tierName', row, container.tableRows)"
                            (keydown.enter)="saveRowInContainer(container, row)"
                            [class.field-error]="shouldShowTierNameError(row)"
                            style="width:90%; border: .125rem solid var(--tui-border-focus); outline: none;"
                            placeholder="Enter tier name" />
                        </tui-textfield>
                      </ng-template>
                    </ng-template>
                  </td>
                </ng-container>

                <!-- Price column with RTL support and edit functionality -->
                <td *tuiCell="'price'" tuiTd>
                  <!-- Display mode with currency formatting -->
                  <ng-container *ngIf="!row.isEditMode; else priceEdit">
                    <span [dir]="getTextDirection()">
                      <!-- LTR currency display -->
                      <ng-container *ngIf="!isRTL">
                        {{ (currencySymbol + (row.price | number:'1.2-2')) }}
                      </ng-container>
                      <!-- RTL currency display -->
                      <ng-container *ngIf="isRTL">
                        {{ ((row.price | number:'1.2-2') + currencySymbol) }}
                      </ng-container>
                    </span>
                  </ng-container>
                  <!-- Edit mode -->
                  <ng-template #priceEdit>
                    <tui-textfield (mousedown)="$event.stopPropagation()"
                      [class.field-error]="shouldShowPriceError(row)">
                      <input tuiInputNumber [ngModel]="row.price" [ngModelOptions]="options"
                        (ngModelChange)="onValueChange($event, 'price', row, container.tableRows)"
                        (keydown.enter)="saveRowInContainer(container, row)"
                        [class.field-error]="shouldShowPriceError(row)"
                        style="width:82%; border: .125rem solid var(--tui-border-focus); outline: none;"
                        placeholder="Enter price" />
                    </tui-textfield>
                  </ng-template>
                </td>

                <!-- Tax column - conditionally shown and formatted -->
                <td *tuiCell="'withTax'" tuiTd [style.display]="switch ? 'table-cell' : 'none'">
                  <span [dir]="getTextDirection()">
                    <!-- LTR currency display -->
                    <ng-container *ngIf="!isRTL">
                      {{ (currencySymbol + (calculatePriceWithTax(row, container) | number:'1.2-2'))
                      }}
                    </ng-container>
                    <!-- RTL currency display -->
                    <ng-container *ngIf="isRTL">
                      {{ ((calculatePriceWithTax(row, container) | number:'1.2-2') + currencySymbol)
                      }}
                    </ng-container>
                  </span>
                </td>

                <!-- Available column for Per Unit, Energy Consumption, Per Day -->
                <ng-container
                  *ngIf="container.pricingType === 'Per Unit' || container.pricingType === 'Energy Consumption' || container.pricingType === 'Per Day'">
                  <td *tuiCell="'available'" tuiTd>
                    <!-- Display mode -->
                    <ng-container *ngIf="!row.isEditMode; else availableEdit">
                      <span>{{ (row.available || 'Unlimited') }}</span>
                    </ng-container>
                    <!-- Edit mode -->
                    <ng-template #availableEdit>
                      <tui-textfield (mousedown)="$event.stopPropagation()">
                        <input tuiInputNumber [ngModel]="row.available" [ngModelOptions]="options"
                          (ngModelChange)="onValueChange($event, 'available', row, container.tableRows)"
                          [tuiNumberFormat]="{precision: 0}"
                          style="border: .125rem solid var(--tui-border-focus); outline: none; width:90%"
                          placeholder="Enter available units" />
                      </tui-textfield>
                    </ng-template>
                  </td>
                </ng-container>

                <!-- Description column -->
                <td *tuiCell="'description'" tuiTd>
                  <!-- Display mode -->
                  <ng-container *ngIf="!row.isEditMode; else descriptionEdit">
                    <span>{{ row.description }}</span>
                  </ng-container>
                  <!-- Edit mode -->
                  <ng-template #descriptionEdit>
                    <tui-textfield (mousedown)="$event.stopPropagation()">
                      <input tuiTextfield [ngModel]="row.description" [ngModelOptions]="options"
                        (ngModelChange)="onValueChange($event, 'description', row, container.tableRows)"
                        (keydown.enter)="saveRowInContainer(container, row)"
                        style="width:90%; border: .125rem solid var(--tui-border-focus); outline: none;"
                        placeholder="Enter description" />
                    </tui-textfield>
                  </ng-template>
                </td>

                <!-- Unit Type column -->
                <!-- <td *tuiCell="'unitType'" tuiTd class="unit-type-col">
                  <ng-container *ngIf="container.pricingType === 'Time Based'">
                    <ng-container *ngIf="!row.isEditMode; else unitEdit">
                      <tui-chip [size]="'xs'" appearance="neutral">
                        {{ ((container.facilityType &&
                        container.facilityType.toLowerCase().includes('valet')) ? 'Hourly'
                        : (row.unitType || 'Hourly')) }}
                      </tui-chip>
                    </ng-container>
                    <ng-template #unitEdit>
                      <ng-container
                        *ngIf="container.facilityType && container.facilityType.toLowerCase().includes('valet'); else normalUnitEdit">
                        <tui-chip [size]="'xs'" appearance="neutral">
                          Hourly
                        </tui-chip>
                      </ng-container>
                      <ng-template #normalUnitEdit>
                        <tui-textfield tuiChevron class="select" (mousedown)="$event.stopPropagation()">
                          <input tuiSelect placeholder="Select unit type" [ngModel]="row.unitType"
                            [ngModelOptions]="options"
                            (ngModelChange)="onValueChange($event, 'unitType', row, container.tableRows)" />
                          <tui-data-list-wrapper *tuiTextfieldDropdown new [items]="timeBasedUnitTypes" />
                        </tui-textfield>
                      </ng-template>
                    </ng-template>
                  </ng-container>

                  <ng-container *ngIf="container.pricingType !== 'Time Based'">
                    <tui-chip [size]="'xs'" appearance="neutral">
                      {{ getUnitTypeLabelById(container.unitTypeId) }}
                    </tui-chip>
                  </ng-container>
                </td> -->



                <!-- Status column -->
                <td *tuiCell="'unit'" tuiTd>

                  <!-- <ng-container *ngIf="!row.isEditMode; else unitEdit">
                  <span tuiStatus="var(--tui-status-{{container.isActive ? 'positive' : 'negative'}})"> {{ container.isActive ? 'Active' : 'Inactive' }}</span>
                </ng-container> -->
                  <!-- <ng-template #unitEdit>
                  <tui-textfield tuiChevron class="select">
                    <select placeholder="Status" tuiTextfield [ngModel]="row.unit" [ngModelOptions]="options"
                      (ngModelChange)="onValueChange($event, 'unit', row, container.tableRows)"></select>
                    <tui-data-list-wrapper *tuiTextfieldDropdown [items]="['Active', 'Inactive']" />
                  </tui-textfield>
                </ng-template> -->
                </td>

                <!-- Action buttons column -->
                <td *tuiCell="'actions'" tuiTd class="number last">
                  <!-- Edit/Save button -->
                  <button [appearance]="row.isEditMode ? 'secondary' : 'flat'" size="xs" tuiIconButton type="button"
                    (click)="row.isEditMode ? saveRowInContainer(container, row) : editRowInContainer(container, row)"
                    [appPermissionDisable]="'Facility Services'" [appPermissionAction]="'update'"
                    [appPermissionSubModule]="'Facilities Setup'"
                    [iconStart]="row.isEditMode ? (savingRowId() === row.id ? '@tui.loader' : '@tui.check') : '@tui.pen-line'"
                    [title]="row.isEditMode && !canSaveRow(row) ? 'Price is required to save' : ''"
                    [style.border]="row.isEditMode && !canSaveRow(row) ? '2px solid var(--tui-error-fill)' : ''"
                    [style.border-radius]="row.isEditMode ? '0.375rem' : ''"
                    [style.background]="row.isEditMode ? 'var(--tui-status-positive)' : null"
                    [style.backgroundColor]="row.isEditMode ? 'var(--tui-status-positive)' : null"
                    [style.color]="row.isEditMode ? '#fff' : null" class="action-icon"
                    [class.save-check-btn]="row.isEditMode"
                    [disabled]="savingRowId() === row.id || deletingRowId() === row.id"
                    [class.animate-spin]="savingRowId() === row.id">
                  </button>

                  <!-- Cancel/Delete button -->
                  <button appearance="flat" size="xs" tuiIconButton type="button" [style.margin-left.rem]="0.25"
                    (click)="onRowActionButtonClick(container, row)" [appPermissionDisable]="'Facility Services'"
                    [appPermissionAction]="'delete'" [appPermissionSubModule]="'Facilities Setup'"
                    [iconStart]="row.isEditMode ? '@tui.x' : (deletingRowId() === row.id ? '@tui.loader' : '@tui.trash')"
                    class="action-icon" [disabled]="savingRowId() === row.id || deletingRowId() === row.id"
                    [class.animate-spin]="deletingRowId() === row.id">
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </tui-scrollbar>

      <!-- Add new pricing tier section - hidden when 24h tier exists -->
      <div class="add-more-tier">
        <header tuiHeader="h6" *ngIf="!has24hTierPublic(container)">
          <hgroup tuiTitle>
            <p tuiSubtitle [style.font-size.px]="13">Price Items</p>
          </hgroup>
          <aside tuiAccessories>
            <div class="flex" style="gap: 1rem; align-items: center;">
              <!-- Add new pricing tier button - hidden ONLY for Helmet Locker when 1 item exists -->
              <button appearance="outline" iconStart="@tui.plus" size="s" tuiButton type="button"
                (click)="addNewRowToContainer(container)" [appPermissionDisable]="'Facility Services'"
                [appPermissionAction]="'create'" [appPermissionSubModule]="'Facilities Setup'"
                *ngIf="!(container.facilityType?.toLowerCase()?.includes('helmet') && container.tableRows?.length >= 1) && !(container.facilityType?.toLowerCase()?.includes('valet') && getAvailableVehicleServices(container).length === 0)">
                {{ (container.pricingType === 'Flat Rate' || container.pricingType === 'Per Day' ||
                container.pricingType === 'Per Unit') ? 'Add Items' : 'Add Items' }}
              </button>
            </div>
          </aside>
        </header>
      </div>

      <!-- Image container with upload button -->
      <div class="icon-list" style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap;">
        <!-- Display uploaded images if available -->
        <ng-container *ngIf="container.uploadedImages && container.uploadedImages.length > 0">
          <tui-avatar *ngFor="let image of container.uploadedImages; let i = index" appearance="custom"
            class="icon-faclity" [style.margin-right.rem]="i < container.uploadedImages.length - 1 ? 0 : 0"
            (click)="showImagePreview(container, i)" style="cursor: pointer;">
            <img [src]="getImageUrl(image)" [alt]="container.facilityType" />
          </tui-avatar>
        </ng-container>

        <!-- Upload button -->
        <button appearance="secondary" size="l" tuiButton type="button" class="facility-add-image-btn"
          (click)="uploadImages(container)" [appPermissionDisable]="'Facility Services'"
          [appPermissionAction]="'update'" [appPermissionSubModule]="'Facilities Setup'">
          Photos
        </button>
      </div>

      <!-- Footer with facility description -->
      <footer>
        <p tuiText class="tui-text_s">
          {{ (container.description || 'Secure helmet storage with individual compartments.') }}
        </p>
      </footer>
    </div>
  </ng-container>


  <div tuiAppearance="outline" tuiCardLarge [style.borderRadius.rem]="0.75" [style.padding.rem]="'1.25'"
    [style.margin-top.rem]="1.25" [style.margin-bottom.rem]="2.25" [style.grid-column]="'2 / span 10'">
    <div tuiCell="m">
      <div tuiTitle>
        <div class="tui-text_body-m" [style.color]="'var(--tui-text-secondary)'">
          <b [style.color]="'var(--tui-text-primary)'" [style.line-height.rem]="1.5">Facility
            Management:</b>
          <br>Configure various facility services with different pricing models. Enable/disable
          facilities as needed and
          track usage and revenue for each service.
        </div>
      </div>
    </div>
  </div>



  <!-- Image Preview Template -->
  <ng-template #preview let-preview>
    <tui-preview [rotatable]="true" (tuiSwipe)="onPreviewSwipe($event)">
      <tui-preview-title>{{ previewTitle }}</tui-preview-title>
      <tui-preview-pagination [length]="previewLength" [(index)]="previewIndex" />

      <!-- <button
        *ngIf="previewContainer && previewContainer.uploadedImages && previewContainer.uploadedImages.length > 0"
        iconStart="@tui.trash"
        tuiIconButton
        tuiPreviewAction
        type="button"
        (click)="deleteImageFromPreview()"
      >
        Delete
      </button>
      <button
        iconStart="@tui.download"
        tuiIconButton
        tuiPreviewAction
        type="button"
        (click)="downloadImage()"
      >
        Download
      </button> -->
      <button iconStart="@tui.x" tuiIconButton tuiPreviewAction type="button" (click)="preview.complete()">
        Close
      </button>

      <img [src]="previewContent" alt="preview"
        style="width: 100%; height: 100%; min-width: 280px; min-height: 280px; max-width: 80vw; max-height: 80vh; object-fit: contain;" />
    </tui-preview>
  </ng-template>

  <!-- Upload Images Dialog -->
  <ng-template #uploadDialog let-observer>
    <div class="upload-dialog-content">
      <header tuiHeader="h4">
        <hgroup tuiTitle>
          <h3>Bring Your Facility to Life</h3>
          <p tuiSubtitle>Upload clear entry photos, signage, and layout images to help visitors find and navigate
            your parking effortlessly. Great visuals make parking seamless and trustworthy.</p>
        </hgroup>
      </header>

      <div class="upload-dialog-body">
        <label tuiInputFiles [style.margin-top.rem]="1" [style.margin-bottom.rem]=".3" data-no-auto-translate="true"
          translate="no">
          <input #validator="tuiInputFilesValidator" accept="image/jpeg,image/png,image/webp" tuiInputFiles
            [formControl]="fileControl" [multiple]="true" [maxFileSize]="maxImageSizeBytes"
            (reject)="onReject($event)" />
        </label>

        <small class="upload-dialog-helper">
          Add visuals related to the facility (optional). JPEG, PNG, WebP only. Max 5 files, 2MB each ({{
          getTotalFilesCount() }}/5).
        </small>

        <!-- API / upload error -->
        <small *ngIf="uploadErrorMessage" class="upload-dialog-error">
          {{ uploadErrorMessage }}
        </small>

        <!-- Existing Images + Selected Files Display -->
        <div class="upload-preview-container">
          <!-- Existing images -->
          <div class="upload-preview-item" *ngFor="let image of existingImages; let i = index">
            <tui-avatar [src]="image" [style.border-radius]="'0.75rem'" [size]="'l'" [style.cursor]="'pointer'" />
            <button appearance="glass" tuiButtonClose tuiIconButton type="button" size="xs" class="remove-upload-btn"
              (click)="removeExistingImage(i); $event.stopPropagation()" tuiHint="Remove image" tuiHintDirection="right"
              [disabled]="isUploadingImages">Close</button>
          </div>

          <!-- Newly uploaded files -->
          <ng-container *ngIf="accepted$ | async as acceptedFiles">
            <div class="upload-preview-item" *ngFor="let file of acceptedFiles; let i = index">
              <tui-avatar [src]="getFileUrl(file)" [style.border-radius]="'0.75rem'" [size]="'l'"
                [style.cursor]="'pointer'" />
              <button appearance="glass" tuiButtonClose tuiIconButton type="button" size="xs" class="remove-upload-btn"
                (click)="onRemove(file); $event.stopPropagation()" tuiHint="Remove image" tuiHintDirection="right"
                [disabled]="isUploadingImages">Close</button>
            </div>
          </ng-container>
        </div>

        <!-- Error files display -->
        <tui-files *ngIf="rejected.length > 0" class="upload-rejected-files">
          <tui-file *ngFor="let file of rejected" [file]="file" state="error">
            <span class="tui-text_body-s">File exceeds 2MB limit</span>
          </tui-file>
        </tui-files>
      </div>

      <div class="upload-dialog-actions">
        <button tuiButton type="button" appearance="primary" size="m" (click)="confirmUpload(observer)"
          [style.width]="'100%'" [disabled]="isUploadingImages">
          {{ isUploadingImages ? 'Uploading...' : 'Upload' }}
        </button>
      </div>
    </div>
  </ng-template>
</main>